import { useMutation } from 'react-query';

import { updateBusinessUnit } from 'shared/api/business-units/http';

const useMutateUpdateBusinessUnit = (options = undefined) =>
  useMutation(({ id, businessUnit }) => updateBusinessUnit(id, businessUnit), options);

export default useMutateUpdateBusinessUnit;
